import { Component, OnInit, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { OverlayContainer } from '@angular/cdk/overlay';


@Component({
  selector: 'app-fccp-layout',
  templateUrl: './fccp-layout.html',
  styleUrls:['./fccp-layout.scss']
})
export class FccpLayout implements OnInit {
  showlogin:boolean=true;
  showurl:any;
  imgurl:string;
    constructor(public router: Router , private overlay: OverlayContainer      ) {
      this.overlay.getContainerElement().classList.add('theme-light');
      var imgarr = ['./assets/images/fccp_bg.jpg','./assets/images/fccp_bg1.jpg','./assets/images/fccp_bg2.jpg','./assets/images/fccp_bg3.png']
      this.imgurl = imgarr[Math.floor(Math.random()*imgarr.length)];
      
  }

  ngOnInit() {
    this.showurl=this.router.url;
    console.log(this.router.url);
  }                                     

  logout()
  {
    window.sessionStorage.clear();
    window.sessionStorage.setItem('jwttoken','' )
    this.router.navigate(['/fccp/fccplogin']);
  }
}
